import { connect } from 'react-redux'

import { setAuth } from '../actions'

import CompleteInvite from '../components/CompleteInvite'

const mapDispatchToProps = {
  setAuth,
}

export default connect(null, mapDispatchToProps)(CompleteInvite)
